/* ================================================== */
/* FLICKITY > Jumbotron
/* ================================================== */

function flickityJumbotron() {

	var $carousel = $('.carousel--jumbotron.carousel--enabled');

	if ($carousel.length) {

		$carousel.each(function(index, element) {

			var total = $('.carousel__item', element).length;

			// Init
			var $carousel = $(element).flickity({
				cellSelector   : '.carousel__item',
				autoPlay       : 4000*2,
				imagesLoaded   : true,
				adaptiveHeight : true,
				wrapAround     : true,
				draggable      : true,
				freeScroll     : false,
				prevNextButtons: (total > 1) ? true : false,
				pageDots       : (total > 1) ? true : false,
				arrowShape     : 'M71.988 0a6.237 6.237 0 0 0-4.421 1.834L23.829 45.58a6.255 6.255 0 0 0 0 8.839L67.567 98.17a6.258 6.258 0 0 0 8.842 0 6.255 6.255 0 0 0 0-8.84L37.086 50.003l39.323-39.33A6.255 6.255 0 0 0 71.988 0z'
			});

			// Refresh on image load
			$(element).imagesLoaded().progress(function(instance, image) {
				$carousel.flickity('resize');
			});

			// Refresh on resize
			$(window).on('scroll resize orientationchange', function() {
				$carousel.flickity('resize');
			});

			// Load
			$carousel.addClass('loaded');

			// Controls
			flickityControls($carousel);

			// Accessibility
			flickityDotsAccessibility($carousel);

		});

		// Accessibility
		flickityAccessibility();

	}

}

$(document).ready(flickityJumbotron());